import { Box } from '@rsos/base-components';
import styled, { Theme } from '@rsos/theme/styled';

export const Wrapper = styled(Box).attrs({
  my: 24,
  color: 'primaryText',
})``;

export const TableWrapper = styled(Box).attrs(
  ({ theme, height }: { theme: Theme; height?: number }) => ({
    overflow: 'auto',
    height: height ? `${height}px` : 'auto',
    border: `solid 1px ${theme.colors.heavyLineOutline}`,
    borderRadius: '5px',
    width: '100%',
  }),
)`
  && {
    table {
      border-collapse: collapse;
      border-spacing: 0;
      width: 100%;

      th:nth-child(1) {
        width: 28.5%;
      }
      th:nth-child(2) {
        width: 57%;
      }
      th:nth-child(3) {
        width: 14.5%;
      }
    }
    th {
      position: sticky;
      top: 0;
      background: ${({ theme }) => theme.colors.foreground};
      padding: 10px 16px;
      text-align: left;
      font-size: 12px;
    }
    td {
      padding: 10px 16px;
      font-size: 14px;
    }
  }
`;

export const Row = styled.tr`
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
`;

export const EmptyStateCell = styled.td.attrs(
  ({ height }: { height?: number }) => ({
    colSpan: 3,
    style: {
      height: height ? `${height}px` : 'auto',
      verticalAlign: 'middle',
    },
  }),
)``;

export const IntermediateWrapper = styled(Box).attrs(
  ({ theme, height }: { theme: Theme; height?: number }) => ({
    align: 'center',
    justify: 'center',
    height: height ? `${height}px` : '100%',
    border: `solid 1px ${theme.colors.heavyLineOutline}`,
    borderRadius: '5px',
    mb: 10,
  }),
)``;
